import {ToMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';

export class UnvalidatedZipCode {
  public readonly key = 'UnvalidatedZipCode';
  public readonly value = '';
}

export class InvalidZipCode {
  public readonly key = 'InvalidZipCode';

  constructor(public readonly value: string) {}
}

export class ValidZipCode {
  public static create(value: string) {
    const formattedValue = value.trim();

    const isValid = /^(\d{5}|\d{9})$/.test(formattedValue);

    return isValid || formattedValue.length === 0
      ? new ValidZipCode(formattedValue)
      : new InvalidZipCode(formattedValue);
  }

  public readonly key = 'ValidZipCode';
  constructor(public readonly value: string) {}
}

export type ZipCode = ValidZipCode | InvalidZipCode | UnvalidatedZipCode;

export type ZipCodeOptions<TReturn> = ToMatchOptions<ZipCode, 'key', TReturn>;

export const matchZipCode = <TReturn>(zipCode: ZipCode, options: ZipCodeOptions<TReturn>): TReturn => {
  switch (zipCode.key) {
    case 'InvalidZipCode':
      return options.InvalidZipCode(zipCode);
    case 'ValidZipCode':
      return options.ValidZipCode(zipCode);
    case 'UnvalidatedZipCode':
      return options.UnvalidatedZipCode(zipCode);
  }
};

export const isValidZipCode = (zip: ZipCode): zip is ValidZipCode => zip.key === 'ValidZipCode';

export const EmptyZipCode = new ValidZipCode('');
export const isEmptyZipCode = (zip: ZipCode): zip is UnvalidatedZipCode => zip.value.length === 0;

export const unmaskZipCode = (value: string | undefined) => {
  return `${value?.replace(/\D/g, '')}`;
};

export const maskZipCode = (zipCode: string | undefined) => {
  if (!zipCode) {
    return '';
  }

  zipCode = unmaskZipCode(zipCode);
  if (zipCode.length > 5) {
    return `${zipCode.slice(0, 5)}-${zipCode.slice(5)}`;
  } else {
    return zipCode;
  }
};
